const INCOME_OPTIONS = [
  'Prefer not to say',
  'Under $50k',
  '$50k - $100k',
  '$100k - $200k',
  '$200k - $500k',
  '$500k+',
  'Retired',
];

const USE_CASES = [
  'Personal collection/hobby',
  'Daily transportation',
  'Business (shop/dealer/club)',
  'Fleet management',
  'Investment/resale',
  'Track/performance',
];

const REFERRAL_OPTIONS = [
  'Google search',
  'Friend referral',
  'Car club/forum',
  'Social media',
  'YouTube',
  'Other',
];

export default function StepOptionalProfile({ data, update, onNext, onBack }) {
  const uses = Array.isArray(data.primaryUseCases) ? data.primaryUseCases : [];

  function toggleUse(use) {
    const next = uses.includes(use) ? uses.filter((u) => u !== use) : [...uses, use];
    update({ primaryUseCases: next });
  }

  return (
    <div className="screen">
      {/* Header with Back and Skip */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <button
          onClick={onBack}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            background: 'none', border: 'none', color: 'var(--text-secondary)',
            fontSize: '0.875rem', cursor: 'pointer', padding: 0,
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back
        </button>
        <button
          onClick={onNext}
          style={{
            background: 'none', border: 'none', color: 'var(--accent)',
            fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer', padding: '4px 0',
          }}
        >
          Skip
        </button>
      </div>

      <h1 className="screen-title" style={{ fontSize: '1.25rem', marginBottom: 4 }}>
        A few more details
      </h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.8125rem', marginBottom: 24 }}>
        All optional — helps us tailor recommendations
      </p>

      {/* Primary Use Cases (moved up) */}
      <div className="form-group">
        <label className="form-label">How do you use your vehicles? <span style={{ fontWeight: 400, color: 'var(--text-muted)' }}>(Select all that apply)</span></label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {USE_CASES.map((use) => (
            <button
              key={use}
              type="button"
              className={`chip${uses.includes(use) ? ' selected' : ''}`}
              onClick={() => toggleUse(use)}
            >
              {use}
            </button>
          ))}
        </div>
      </div>

      {/* Annual Income (renamed from Salary Range) */}
      <div className="form-group">
        <label className="form-label">Annual Income</label>
        <select
          className="form-select"
          value={data.salaryRange || ''}
          onChange={(e) => update({ salaryRange: e.target.value })}
        >
          <option value="">Select range (optional)</option>
          {INCOME_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.6875rem', marginTop: 4 }}>
          Helps us recommend budget-appropriate solutions
        </p>
      </div>

      {/* Referral Source */}
      <div className="form-group">
        <label className="form-label">How did you hear about us?</label>
        <select
          className="form-select"
          value={data.referralSource || ''}
          onChange={(e) => update({ referralSource: e.target.value })}
        >
          <option value="">Select (optional)</option>
          {REFERRAL_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      <div className="nav-row">
        <button className="btn btn-primary" onClick={onNext}>
          Continue
        </button>
      </div>
    </div>
  );
}
